module.exports = __webpack_public_path__ + "img/box.0098563f.png";